import { IconProps } from '@amzn/awsui-components-core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faBullhorn, faCircleCheck, faHouseCircleCheck, faLightbulb, faMobileAlt, faRocket, faUsers } from '@fortawesome/free-solid-svg-icons';

interface CardConfigActions {
  buttonText: string;
  icon?: IconProps.Name;
  path: string;
  embedHeader?: boolean;
}

export interface CardConfiguration {
  Header: string;
  Content: string;
  Actions: CardConfigActions[];
  Icon: IconProp;
}

export const adminCards: CardConfiguration[] = [
  {
    Header: 'Apps',
    Content: 'Create, edit, and manage applications listed in FinSuite.',
    Actions: [
      {
        buttonText: 'Manage Apps',
        path: '/admin/applications',
        embedHeader: true
      }
    ],
    Icon: faMobileAlt
  },
  {
    Header: 'Product Launches',
    Content: 'Publish updates and launch announcements visible on the homepage and app pages.',
    Actions: [{ buttonText: 'Go', path: '/admin/announcements', embedHeader: true }],
    Icon: faRocket
  },
  {
    Header: 'Homepage',
    Content: 'Customize the layout, links, and content on the FinSuite homepage.',
    Actions: [{ buttonText: 'Go', path: '/admin/manage-homepage', embedHeader: true }],
    Icon: faHouseCircleCheck
  },
  {
    Header: 'Teams',
    Content: 'Add or update team profiles and members shown in FinSuite.',
    Actions: [{ buttonText: 'Go', path: '/admin/manage-team-page', embedHeader: true }],
    Icon: faUsers
  }
];
